<template>
  <div class="container1">
    <div v-if="!isCovertMode" class="img-wrapper">
      <img src="../assets/img/d.png"/>
    </div>
      <div class="container-form">
      <template>
        <van-form @submit="onSubmit">
          <van-field
            v-model="phone"
            name="phone"
            label="手机号"
            left-icon="user-o"
          >
            <van-button
              slot="button"
              size="small"
              type="primary"
              @click="sendVerifycode()"
              :disabled="!disabledCodeBtn"
            >{{codeText}}</van-button>
          </van-field>
          <van-field
            v-model="verifycode"
            name="code"
            label="验证码"
            left-icon="chat-o"
          />
          <van-field
            v-model="password"
            type="password"
            name="password"
            label="密码"
            left-icon="closed-eye"
          />
          <div style="margin: 16px;">
            <!-- <van-button round block type="info" native-type="submit">重设密码</van-button> -->
            <van-button round block type="info" native-type="submit" v-on:click="resetPassword">
              提交
            </van-button>
					</div>
        </van-form>
      </template>
    </div>
  </div>
  
</template>
<script>
import Vue from "vue";
import Vuex from 'vuex'
import { app } from "../../utils/app";
import { Form, Field, Button, CellGroup, Toast,Dialog,Overlay } from "vant";
import { getValidateCode,shopLogin,updateShopPwd} from "../../utils/api";
Vue.use(Vuex)
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(CellGroup);
Vue.use(Toast);
Vue.use(Overlay);
export default {
  data() {
    return {
      username: "", //用户名
      password: "", //密码
      phone: "", //手机号
      verifycode: "", //验证码
      loginType: 0, //登录方式0账号密码1手机号验证码
      codeText: "验证码",
      disabledCodeBtn: true,
      token: "",
      show:false,
      isCovertMode:this.$isCovertMode,
    };
  },
  async created() {
    // app.storage.set("token", "bd73938c37ec421fa545e530990d4cf4");
    let t = await app.storage.get("token");
    this.token = t;
  },
  methods: {
    onSubmit(values) {
      // console.log("submit", values);
    },
    typeChange(e) {
      // console.log(e.target.dataset.type);
      this.loginType = e.target.dataset.type;
    },
    // 向后台要验证码方法
    async sendVerifycode() {
      if(this.verifyPhone()){
        Toast(this.verifyPhone())
      }else{
        let params = {
          mobileNo: this.phone,
          token: this.token,
        };
        let res = await getValidateCode(params);
        //  用手机号向后台换取验证码，发送成功则开始调用倒计时分方法
        // console.log('getValidateCode:',res)
        if (res) {
          this.countDown(60);
          Toast(res.data.message)
        }
      }
    },
    // 表单校验方法
    verifyPhone() {
      if (!this.phone) {
        return "请输入手机号";
      } else if (this.phone.length !== 11) {
        return "请输入11位手机号";
      } else {
        return false;
      }
    },
    // 倒计时方法
    countDown(time) {
      if (time === 0) {
        this.disabledCodeBtn = true;
        this.codeText = "验证码";
        return;
      } else {
        this.disabledCodeBtn = false;
        this.codeText = "发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    // 登录
    async goLogin() {
      let params;
      if (this.loginType == 0) {
        params = {
          username: this.username,
          password: this.password,
          loginType: 0,
        };
      } else {
        params = {
          username: this.phone,
          password: this.verifycode,
          loginType: 1,
        };
      }
      let res1 = await shopLogin(params)
      console.log('res1',res1,res1.data.msg)
      if(res1.status == 200){//登录成功
        if(res1.data.code == 0){
          let shopToken = res1.data.usertoken
					let userInfo = res1.data.user
					let shopInfo = res1.data.shop
					this.$store.commit('setShopToken',shopToken)
					// this.$store.commit('setUserInfo',userInfo)
					this.$store.commit('setShopInfo',shopInfo)
          app.storage.set("shopToken", shopToken)
          app.storage.set("shopInfo", shopInfo)
          app.storage.set("shopUserInfo",userInfo)
					this.$router.push({path:'/ShopData'})
        }else{
          Dialog.alert({
            message: res1.data.msg
          }).then(() => {
            console.log('用户确认')
          });
        }
      }else{
        Dialog.alert({
          message: res1.data.msg
        }).then(() => {
          console.log('用户确认')
        });
      }
    },
    // getValidateCode() {},
    overlayClick(){
      this.show = false
    },
		goRegistPage(){
			this.$router.push('/ShopRegist');
    },
    //重置密码
    async resetPassword(){
      let params= {
        password:this.password,
        usertoken:this.token,
        validateCode:this.verifycode
      }
      let res = await updateShopPwd(params)
      if (res.data.code == 0) {
        Toast('修改成功请重新登录')
        Dialog.alert({
          title: '标题',
          message: '弹窗内容',
        }).then(() => {
          // on close
        });
      }
    }
  },
};
</script>
<style lang="less">
.container1 {
  background-color: #ffffff;
  .img-wrapper {
    background-color: #ffffff;
    text-align: center;
    height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 40%;
    }
  }
  .body .img1-box img {
    width: 100%;
  }
  .body .img2-box img {
    width: 100%;
  }
  .login-box {
    .tags {
      display: flex;
      justify-content: space-around;
      padding: 0 30px;
      .tag {
        text-align: center;
        font-size: 16px;
        height: 22px;
        padding: 0 10px;
        line-height: 22px;
        color: #888888;
        box-sizing: border-box;
        &.active {
          font-size: 16px;
          color: #333333;
          border-bottom: 1px solid #dedede;
        }
      }
    }
  }
  .container-form {
    padding: 10px 20px;
    .van-button--small {
      height: 24px;
      line-height: 24px;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 320px;
    height: 360px;
    padding: 40px 20px 20px 20px;
    background-color: #fff;
    border-radius: 20px;
    font-size: 22px;
    .title{
      font-size: 26px;
    text-align: center;
    }
    .title2{
      font-size: 20px;
      margin-top: 20px;
      text-align: left;
    }
    .url{
      font-size: 24px;
      font-weight: bold;
      color:#0364e4;
      text-align: left;
    }
    .bot{
      text-align: right;
      color: #FF3366;
      font-size: 22px;
      margin-top: 100px;
      font-weight: bold;
    }
  }
}
</style>
